import { Component } from '@angular/core';
import { CommonModule, NgIf, Location } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';
import { WebsocketService } from '../../services/websocket.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AnimationService } from '../../services/animation.service';
import { AuthService } from '../../services/auth.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-telegram',
  standalone: true,  
  imports: [TranslatePipe,  QRCodeModule, CommonModule, NgIf],
  templateUrl: './telegram.component.html',
  styleUrl: './telegram.component.scss',  
})
export class TelegramComponent {
  telegramLink = '';
  chatId: number | null = null;
  constructor(private websocketService: WebsocketService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private animationService: AnimationService,
    private auth: AuthService
  ) {
    
  }
  
  ngOnInit() {
    //console.log(this.auth.getUserData$);
    this.auth.getUserData$.pipe().subscribe(userData => {
      //console.log('User data updated:', userData);
      this.chatId = userData?.chatId || null;
    });
    this.telegramLink = '';    
    this.websocketService.messages$.subscribe(
        msg => {
          //console.log('TG WebSocket message received:', msg);
          if (msg.type === 'BOTLINK') {
            this.telegramLink = msg.payload;
          }
        });
  }

  joinTelegram() {
    // send message to websocket service
    this.websocketService.sendMessage({
      type: 'TELEGRAMREQUEST',
      payload: {}
    });
  }

  public back(): void {
    this.animationService.triggerLeaveAnimation();
    setTimeout(() => {
      this.location.back();      
    }, 150); // Half the animation duration for smoother transition
  }  
}
